import Vue from 'vue'
import VueRouter from 'vue-router'
import { BASE_URL } from '@/config/environment'

Vue.use(VueRouter)

const routes = [
  {
    path: '/points/:token',
    name: 'points',
    component: () => import(/* webpackChunkName: "points" */ '../views/Points.vue')
  },
  {
    path: '/daypass/:token',
    name: 'daypass',
    component: () => import(/* webpackChunkName: "daypass" */ '../views/Daypass.vue')
  },
  {
    path: '/signature/:token',
    name: 'signature',
    component: () => import(/* webpackChunkName: "signature" */ '../views/DocumentSignature.vue')
  },
  {
    path: '*',
    redirect: { name: 'points' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: BASE_URL,
  routes
})

export default router
